import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { formatCurrency, formatDocument } from '../helpers/csvValidation';
import { NfseBatchRecord } from '../types/nfse.types';
import { RecordStatusBadge } from './StatusBadge';

interface BatchDetailTableProps {
  records: NfseBatchRecord[];
}

const BatchDetailTable: React.FC<BatchDetailTableProps> = ({ records }) => {
  if (records.length === 0) {
    return (
      <Text color="gray.500" textAlign="center" py="2rem">
        Nenhum registro encontrado
      </Text>
    );
  }

  return (
    <TableContainer>
      <Table variant="simple" size="sm">
        <Thead>
          <Tr h="3.5rem">
            <Th textAlign="left" w="80px">
              ID
            </Th>
            <Th textAlign="left" w="160px">
              Documento
            </Th>
            <Th textAlign="center" w="80px">
              Tipo
            </Th>
            <Th textAlign="right" w="120px">
              Valor
            </Th>
            <Th textAlign="center" w="100px">
              Cliente ID
            </Th>
            <Th textAlign="center" w="120px">
              Status
            </Th>
          </Tr>
        </Thead>

        <Tbody>
          {records.map((record) => (
            <Tr key={record.id} _hover={{ bg: 'gray.50' }}>
              <Td>{record.id}</Td>
              <Td>{formatDocument(record.document)}</Td>
              <Td textAlign="center">{record.documentType}</Td>
              <Td textAlign="right">{formatCurrency(record.value)}</Td>
              <Td textAlign="center">
                {record.customerId ?? (
                  <Text color="gray.400" fontSize="sm">
                    -
                  </Text>
                )}
              </Td>
              <Td textAlign="center">
                <RecordStatusBadge status={record.status} />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default BatchDetailTable;
